import axios, { AxiosInstance } from 'axios'

const api: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BASEAPIURL,
  headers: { 'Content-Type': 'application/json' },
})

export default api
